<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 v-if="$route.query.action === 'edit'">{{$t('message.doctor_header.title_edit')}}</h2>
        <h2 v-else>{{$t('message.doctor_header.title_new')}}</h2>
        <step :currentStep="1" :maxStep="5" @step_clicked="gotoPage">
          <div slot='1'>{{$t('message.doctor_header.personal_info')}}</div>
          <div slot='2'>{{$t('message.doctor_header.experience')}}</div>
          <div slot='3'>{{$t('message.doctor_header.schedules')}}</div>
          <div slot='4'>{{$t('message.doctor_header.education')}}</div>
          <div slot='5'>{{$t('message.doctor_header.other_info')}}</div>
        </step>
      </div>

      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.doctor_header.personal_info')}}</h4>
        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_general.name_th')}}</h6>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="prefix-th">{{$t('message.doctor_general.prefix')}}</label>
              <input type="text" class="form-control" id="prfix-th" :placeholder="$t('message.doctor_general.prefix_placeholder_th')" v-model="doctor_profile_th.prefix">
            </div>
          </div>
          <div class="col-8">
            <div class="form-group">
              <label for="firstname-th">{{$t('message.doctor_general.firstname')}}</label>
              <input type="text" class="form-control" id="firstname-th" :placeholder="$t('message.doctor_general.firstname')" v-model="doctor_profile_th.firstname">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="lastname-th">{{$t('message.doctor_general.lastname')}}</label>
              <input type="text" class="form-control" id="lastname-th" :placeholder="$t('message.doctor_general.lastname')" v-model="doctor_profile_th.lastname">
            </div>
          </div>

          <div class="col-12">
            <h6>{{$t('message.doctor_general.name_en')}}</h6>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="prefix-en">{{$t('message.doctor_general.prefix')}}</label>
              <input type="text" class="form-control" id="prefix-en" :placeholder="$t('message.doctor_general.prefix_placeholder_en')" v-model="doctor_profile_en.prefix">
            </div>
          </div>
          <div class="col-8">
            <div class="form-group">
              <label for="firstname-en">{{$t('message.doctor_general.firstname')}}</label>
              <input type="text" class="form-control" id="firstname-en" :placeholder="$t('message.doctor_general.firstname')" v-model="doctor_profile_en.firstname">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="lastname-en">{{$t('message.doctor_general.lastname')}}</label>
              <input type="text" class="form-control" id="lastname-en" :placeholder="$t('message.doctor_general.lastname')" v-model="doctor_profile_en.lastname">
            </div>
          </div>
        </div>

        <div class="form-divider"></div>

        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_general.gender')}}</h6>
          </div>

          <div class="col-12">
            <div class="gender-select">
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="m" v-model="doctor.gender"> <i class="fa fa-male fa-lg" aria-hidden="true"></i> {{$t('message.doctor_general.male')}}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="f" v-model="doctor.gender"> <i class="fa fa-female fa-lg" aria-hidden="true"></i> {{$t('message.doctor_general.female')}}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_general.image')}}</h6>
          </div>
          <div class="col-12">
              <drop-zone class="crop-profile-image-dropzone" :class="{'profile-image-active': isProfileImage}" @fileChange="profileImageFileChange" :placeholder="profileImagePlaceholder"></drop-zone>
              <img class="crop-profile-image" ref='crop-profile-image' :src="profile_image_src" />
            </div> 
        </div>

        <div class="row">
          <div class="col-12">
            <h6>{{$t('message.doctor_general.albums')}}</h6>
          </div>
          <div class="col-12">
            <div id='alblum-wrapper'>
            <div class='image-in-alblum-wrapper' v-for="img in doctor.images" :key="img.id" v-if="!img.is_active">
                <i class="fa fa-2x fa-times remove-image-from-alblum" aria-hidden="true" @click="removeImageFromAlblum(img.id)"></i>
                <img class='image-in-alblum' :src="img.file_thumb" />
            </div>
            <vue-core-image-upload
              :class="['btn', 'btn-primary', 'btn-upload-image']"
              :crop="false"
              :max-file-size="5242880"
              input-of-file="image"
              @imageuploaded="imageAlblumUploaded"
              :url="profile_upload_album" >
                <i title="remove image" 
                   class="fa fa-2x fa-plus plus-image" 
                   aria-hidden="true"></i>
            </vue-core-image-upload>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg">{{$t('action_message.cancel')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <button v-if="$route.query.action === 'edit'" class="btn btn-delete btn-right btn-lg" @click="deleteDoctor">{{$t('action_message.remove')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Crop Modal -->
    <sweet-modal ref='crop-modal' overlay-theme="dark">
      <div>
        <div class='row'>
          <div class='col-md-12'>
            <vue-croppie 
                ref=croppieRef 
                :enableOrientation="true">
            </vue-croppie>
          </div>
          <div class='col-md-12 form-group'>
            <button class="btn btn-lg btn-close" @click.prevent="cancelCrop">{{$t('action_message.cancel')}}</button>
            <button class="btn btn-lg btn-success" @click.prevent="confirmCrop">{{$t('action_message.ok')}}</button>
          </div>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import router from '@/router'
import Step from '@/components/StepBar'
import { dropdown as VDropdown } from 'vue-strap'
import VueCoreImageUpload from 'vue-core-image-upload'
import DoctorMixin from './mixin'
import Ckeditor from '@/components/Ckeditor'
import DropZone from '@/components/DropZone'
import { SweetModal } from 'sweet-modal-vue'
import Alertbar from '@/components/AlertBar'

export default {
  name: 'DoctorEditStep1',
  mixins: [DoctorMixin],
  components: {
    VDropdown,
    Step,
    VueCoreImageUpload,
    Ckeditor,
    DropZone,
    SweetModal,
    Alertbar
  },
  data () {
    return {
      doctor: {},
      doctor_profile_th: {},
      doctor_profile_en: {},
      profile_image_src: '/static/img/no_profile_image.png',
      profile_upload_url: '',
      profile_upload_album: '',
      ckeditorConfig: {
        toolbar: [
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'paragraph', items: ['BulletedList'] },
          { name: 'styles', items: ['Format'] }
        ]
      },
      profileImagePlaceholder: `<i class="fa fa-cloud-upload" aria-hidden="true"> ${this.$t('message.doctor_general.select_image')}</i>`
    }
  },
  computed: {
    isProfileImage () {
      return self.profile_image_src !== null
    }
  },
  methods: {
    saveAndContinue () {
      let routeData = { path: this.next_uri(1), query: {action: this.$route.query.action} }
      this.$http.put(this.doctor_uri,
        // data
        {
          th: this.doctor_profile_th,
          en: this.doctor_profile_en,
          gender: this.doctor.gender
        },
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.status === 'success') {
            this.$toastr.success(this.$t('action_message.save_success'))
            router.push(routeData)
          }
        })
    },
    async removeImageFromAlblum (imgId) {
      if (imgId) {
        if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
          var self = this
          this.$http.delete(this.profile_upload_album + '/' + imgId, { credentials: true }).then(res => {
            self.doctor.images.find(img => img.id === imgId)
            this.refreshDoctor()
          })
        }
      }
    },
    imageAlblumUploaded () {
      this.refreshDoctor()
    },
    refreshDoctor () {
      this.$http.get(this.doctor_uri).then(res => {
        this.doctor = Object.assign({}, res.body.data)
        this.doctor_profile_th = res.body.data.th
        this.doctor_profile_en = res.body.data.en

        // find active profile image
        if (this.doctor.images && this.doctor.images.length > 0) {
          var activeUri = this.doctor.images.find(img => img.is_active)
          this.profile_image_src = activeUri.file_thumb || '' // TODO default profile image src
        }
      }, errorResponse => {
        console.error(errorResponse)
      })
    },
    async deleteDoctor () {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id)).then(res => {
          if (res.body && this.$guser.isClinicMulti()) {
            router.push({path: '/clinic/doctors', query: {ref_clinic_id: this.$route.query.ref_clinic_id}})
          } else if (res.body) {
            router.push({path: '/clinic/doctors'})
          }
        })
      }
    },
    profileImageFileChange (file) {
      this.$loadFile(file, (result) => {
        this.$refs.croppieRef.bind({
          url: result
        })
        this.$refs['crop-modal'].open()
      })
    },
    cancelCrop () {
      this.$refs['crop-modal'].close()
    },
    confirmCrop () {
      this.$refs['crop-modal'].close()
      let options = {
        format: 'jpeg'
      }
      this.$refs.croppieRef.result(options, (output) => {
        var formData = new FormData()
        formData.append('image', this.$processB64ToBlob(output))
        this.$http.post(this.profile_upload_url, formData)
        .then(res => {
          this.$refs['crop-profile-image'].src = res.body.data
        })
      })
    }
  },
  mounted () {
    this.$http.get(this.doctor_uri).then(res => {
      this.doctor = Object.assign({}, res.body.data)
      this.doctor_profile_th = res.body.data.th
      this.doctor_profile_en = res.body.data.en
      this.profile_upload_url = this.$APP_CONFIG.api.admin.upload_doctorme_image(this.doctor.id)
      this.profile_upload_album = this.$APP_CONFIG.api.admin.upload_doctorme_alblum(this.doctor.id)

      if (this.doctor.images && this.doctor.images.length > 0) {
        var activeUri = this.doctor.images.find(img => img.is_active)
        this.profile_image_src = activeUri.file_thumb || '' // TODO default profile image src
      }
    })
  }
}
</script>

<style lang="scss">
@import "../../../assets/base_container";
.step-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.step-container{
  h6{
    color: #5e5e5e;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }
  .step-body{
    background-color: #fff;
    padding-top: 10px;
  }
}
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
}
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check{
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline{ margin-left: 2.5rem;
  }
}
.g-core-image-corp-container {
    margin-top: 55px;
}

.btn-upload-profile-image {
    width: 90%;
    padding-top: 50px;
    padding-bottom: 50px;
    color: #85ace7;
    background-color: transparent;
    border: 0px;
    /* visual debug click area */
    /* border: 1px solid black; */
}
.btn-upload-profile-image:hover {
    color: #85ace7;
    background-color: transparent;
    border: 0px;
}
.btn-upload-image {
    border: 1px dashed #85ace7;
    color: #85ace7;
    background-color: transparent;
    width: 100px;
    height: 100px;
}
.btn-upload-image:hover {
    background-color: rgba(133, 172, 231, 0.5);
}
.plus-image {
    margin-top: 25px;
}
#alblum-wrapper {
    display: flex;
    justify-content: flext-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.image-in-alblum {
    width: 100px;
    height: 100px;
    border: 1px dashed #85ace7;
    margin-right: 0.5em;
    margin-bottom: 10px;
}
.image-in-alblum-wrapper {
    display: inline-block;
}
.image-in-alblum-wrapper:hover .image-in-alblum {
    border: 1px solid #85ace7;
}
.image-in-alblum-wrapper:hover .remove-image-from-alblum {
    display: block;
}
.remove-image-from-alblum {
    color: rgba(200, 0, 0, 0.9); 
    position: absolute;
    margin-left: 75px;
    margin-top: 0px;
    display: none;
    opacity: 0.8;
}

.crop-profile-image-dropzone {
  position: absolute !important;
  border-radius: 100px !important;
}

.crop-profile-image {
    width: 200px;
    height: 200px;
    display: block;
    border-radius: 100px;
    border: dashed 1px #85ace7;
    margin-bottom: 20px;
}

.profile-image-active {
  color: transparent !important;
}

.profile-image-active:hover {
  color: #85ace7 !important;
}

</style>



// WEBPACK FOOTER //
// General.vue?0cc65846